export function formatHourSimple(hourFloat) {
  const hour = Math.floor(hourFloat);
  const minute = Math.round((hourFloat - hour) * 60);

  // Si no hay minutos, solo mostrar la hora en formato 24h
  if (minute === 0) {
    return hour.toString().padStart(2, '0');
  }

  // Si hay minutos, mostrar con formato HH:MM
  return `${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')}`;
}

export function getPeriod(hourFloat) {
  const hour = Math.floor(hourFloat);
  if (hour === 0 || hour < 12) return 'am';
  return 'pm';
}

export function formatRange(range) {
  if (Array.isArray(range)) {
    const startFormatted = formatHourSimple(range[0]);
    const endFormatted = formatHourSimple(range[1]);

    // Usar guion largo (–) en lugar de guion normal
    return `${startFormatted}–${endFormatted}`;
  }
  return range;
}